import { render } from "./AppSubViewHeader.vue?vue&type=template&id=b4c4fb32"
import script from "./AppSubViewHeader.vue?vue&type=script&lang=js"
export * from "./AppSubViewHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__